import { render, staticRenderFns } from "./AMSilkGlass.vue?vue&type=template&id=5f4657e0&scoped=true"
import script from "./AMSilkGlass.vue?vue&type=script&lang=ts"
export * from "./AMSilkGlass.vue?vue&type=script&lang=ts"
import style0 from "./AMSilkGlass.vue?vue&type=style&index=0&id=5f4657e0&prod&lang=scss&scoped=true"
import style1 from "./AMSilkGlass.vue?vue&type=style&index=1&id=5f4657e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4657e0",
  null
  
)

export default component.exports